import type { State } from './types.tsx';

export const INITIAL_STATE: State = {
	hasFetched: false,
	isLoading: false,
	errors: null,
	ruleSummary: null,
	issueProperties: null,
};
